var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('LoginComponent',{attrs:{"msg":"Welcome to RTS 3.0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }